import React from 'react';
export function HeroTestimonial() {
  return <section className="w-full bg-brand-warm-white py-12 md:py-14 px-4 sm:px-6 lg:px-8" data-id="element-103" data-mp="2gmliidwyn9r8">
      <div className="max-w-4xl mx-auto" data-id="element-104" data-mp="188yfpbg5urln">
        <div className="bg-white rounded-lg shadow-sm border-l-4 border-brand-orange overflow-hidden" data-id="element-105" data-mp="u9yzms6prl13">
          {/* Stat section */}
          <div className="text-center px-8 md:px-12 pt-10 md:pt-14 pb-8 md:pb-10 border-b border-gray-100" data-id="element-106" data-mp="z7qo1c85gp0j">
            <div className="mb-4" data-id="element-107" data-mp="kj440x7kv92z">
              <span className="text-6xl md:text-8xl font-bold text-brand-navy tracking-tight" data-id="element-108" data-mp="ki2n4c3vrsdc">
                5-10 <span className="text-4xl md:text-6xl" data-id="element-109" data-mp="pcgrh40it9u5">hours</span>
              </span>
            </div>
            <div className="text-lg md:text-2xl text-brand-orange font-medium mb-4" data-id="element-110" data-mp="fksruftt8mhl">
              of time saved each week
            </div>
            <p className="text-brand-gray-light max-w-2xl mx-auto text-base md:text-lg" data-id="element-111" data-mp="1m2vj2etequa">
              Reported by HTEC Group's Head of Product within three months of
              the program.
            </p>
          </div>

          {/* Testimonial section */}
          <div className="px-8 md:px-12 py-8 md:py-10" data-id="element-112" data-mp="2gcecx3tiigtr">
            <blockquote className="text-xl md:text-2xl font-medium italic text-brand-navy leading-relaxed mb-8" data-id="element-113" data-mp="2gbw8hjwp4war">
              "I think it was the best thing we've ever invested in... if it
              wasn't for that, they wouldn't be where they are and I would still
              be banging my head against a brick wall."
            </blockquote>
            <div className="flex items-center gap-4" data-id="element-114" data-mp="1xmg8qysu57ve">
              <div className="w-12 h-12 rounded-full bg-brand-light-gray border border-gray-200 flex-shrink-0 overflow-hidden" data-id="element-115" data-mp="1xnrbcvajo9kx">
                <img src="https://cdn.magicpatterns.com/uploads/bpRMYStYSiXKhAVVM6tzTx/image.jpg" alt="Pali Dhanoya" className="w-full h-full object-cover" data-id="element-116" data-mp="26ml58dwhqlus" />
              </div>
              <div className="text-base md:text-lg text-brand-gray-light font-medium" data-id="element-117" data-mp="1dx5uzqcngwzx">
                — Pali Dhanoya, Head of Product, HTEC Group
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}